<template>
  <div class="flex h-screen flex-col items-center justify-center py-12 text-center">
    <slot />
  </div>
</template>
